// Mirrors the "Scroll to a Specific Div" block of /js/script.js (bound on
// document ready, before React renders the footer's scroll-top button).
// Called from the Footer component after mount. Idempotent via namespaced events.
export function initScrollToTarget() {
    const $ = window.jQuery;
    if (!$) return;

    $('.scroll-to-target')
        .off('click.reactScroll')
        .on('click.reactScroll', function () {
            const target = $(this).attr('data-target');
            const $target = $(target);
            if (!$target.length) return;

            $('html, body').animate({ scrollTop: $target.offset().top }, 1000);
        });
}
